module.exports = __webpack_public_path__ + "std/img/register-bg.1b7a8ab.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/auth/register-bg.webp
// module id = 228w
// module chunks = 0 7